import React, { useState, useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import { BriefcaseIcon, TrashIcon, CheckIcon, ClockIcon } from '@heroicons/react/24/outline';
import { PlusIcon } from '@heroicons/react/20/solid';
import { createTimeSlotCompanyCompound } from '../services/api_working_hours';
import { validateBreak, validateBreaks, validateTimeSlots } from '../utils/timeslots';
import Swal from 'sweetalert2';




const AddNewTimeSlot = ({ onCancelEdit, workingHour, onAddTimeSlot }) => {
  const { token } = useContext(AuthContext);
  const [workStartTime, setWorkStartTime] = useState('');
  const [workEndTime, setWorkEndTime] = useState('');
  const [error, setError] = useState('');
  const [pauseTimes, setPauseTimes] = useState([]);
  const [creatingPause, setCreatingPause] = useState(false);
  const [workTimeError, setWorkTimeError] = useState('');
  const [breakTimeError, setBreakTimeError] = useState('');
  const [newTimeSlots, setNewTimeSlots] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  const handleCancelClick = () => {
      onCancelEdit();
  };

  const handleWorkStartTimeChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.slice(0, 4);

    let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");
  
    if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
      formattedTime = formattedTime.replace(":", "");
    }
  
    setWorkStartTime(formattedTime);

    if (workEndTime && formattedTime >= workEndTime) {
      setWorkTimeError("L'orario di inizio deve essere precedente all'orario di fine.");
      return;
    } else {
      setWorkTimeError('');
      setError('');
    }
  };

  const handleWorkEndTimeChange = (e) => {
    let inputValue = e.target.value;
  
    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.slice(0, 4);
  
    let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");
  
    if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
      formattedTime = formattedTime.replace(":", "");
    }
  
    setWorkEndTime(formattedTime);

    if (workStartTime && formattedTime <= workStartTime) {
      setWorkTimeError("L'orario di fine deve essere maggiore dell'orario di inizio");
      return;
    } else {
      setWorkTimeError('');
      setError(''); 
    }
  };

  const handleWorkTimeBlur = (field) => {
    let formattedTime = field === 'start' ? workStartTime : workEndTime;
  
    formattedTime = formattedTime.replace(/\D/g, '');
  
    while (formattedTime.length < 4) {
      formattedTime += '0';
    }
  
    formattedTime = formattedTime.slice(0, 4);
  
    const hours = formattedTime.slice(0, 2);
    const minutes = formattedTime.slice(2);
    formattedTime = `${hours}:${minutes}`;
  
    const isValidTime = /^([01]?[0-9]|2[0-4]):[0-5][0-9]$/.test(formattedTime);
  
    if (!isValidTime) {
      if (field === 'start') {
        setWorkStartTime('');
      } else {
        setWorkEndTime('');
      }
      return;
    }
  
    if (field === 'start') {
      setWorkStartTime(formattedTime);      
    } else {
      setWorkEndTime(formattedTime);      
    }
  };
  
  
  const handleAddPause = () => {
    if (!workStartTime || !workEndTime) {
      setWorkTimeError("Prima di aggiungere una pausa, inserisci l'orario di lavoro.");
      return;
    }
  
    if (!creatingPause && pauseTimes.every(pause => pause.confirmed)) {
      setCreatingPause(true);
      setPauseTimes([...pauseTimes, { start_at: '', end_at: '', confirmed: false }]);
      setWorkTimeError('');
    } else {
      setCreatingPause(false);
      setPauseTimes(pauseTimes.filter(pause => pause.confirmed));
      setBreakTimeError('');
    }
  };

  const handlePauseStartTimeChange = (index, e) => {
    const updatedPauseTimes = [...pauseTimes];
    let inputValue = e.target.value;
    
    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.slice(0, 4);
    
    let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");
  
    if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
      formattedTime = formattedTime.replace(":", "");
    }
    
    updatedPauseTimes[index].start_at = formattedTime;
    setPauseTimes(updatedPauseTimes);
  };
  
  const handlePauseEndTimeChange = (index, e) => {
    const updatedPauseTimes = [...pauseTimes];
    let inputValue = e.target.value;
    
    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.slice(0, 4);
    
    let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");
  
    if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
      formattedTime = formattedTime.replace(":", "");
    }
    updatedPauseTimes[index].end_at = e.target.value;
    setPauseTimes(updatedPauseTimes);
  };

const handlePauseTimeBlur = (index, field) => {
  const updatedPauseTimes = [...pauseTimes];
  let formattedTime = updatedPauseTimes[index][field];

  if (typeof formattedTime === 'string') {
    formattedTime = formattedTime.replace(/\D/g, '');

    while (formattedTime.length < 4) {
      formattedTime += '0';
    }

    formattedTime = formattedTime.slice(0, 4);

    const hours = formattedTime.slice(0, 2);
    const minutes = formattedTime.slice(2);
    formattedTime = `${hours}:${minutes}`;

    const isValidTime = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(formattedTime);

    if (!isValidTime) {
      updatedPauseTimes[index][field] = '';
      setPauseTimes(updatedPauseTimes);
      return;
    }

    updatedPauseTimes[index][field] = formattedTime;
    setPauseTimes(updatedPauseTimes);
  }
};

  const handleConfirmPause = (index) => {
    const updatedPauseTimes = [...pauseTimes];
    const currentPause = updatedPauseTimes[index];
    
    try {
      validateBreak(workStartTime, workEndTime, currentPause, pauseTimes);
      currentPause.confirmed = true;
      setPauseTimes(updatedPauseTimes);
      setCreatingPause(false);
      setBreakTimeError('');
    }
    catch(error) {
      console.log(error)
      setBreakTimeError(error.message);
      return;
    }
  };

  const handleDeletePause = (index) => {
    const updatedPauseTimes = [...pauseTimes];
    updatedPauseTimes.splice(index, 1);
    setPauseTimes(updatedPauseTimes);
  };


  const handleSaveTimeSlot = async () => {
    if (workTimeError || error) {
      return;
    }

    if (!workStartTime || !workEndTime) {
      setError("Prima di confermare, inserisci l'orario di lavoro.");
      return;
    }

    setError('');
    setIsSaving(true);
    
    try {
      const breaks = pauseTimes.map(breakItem => ({
        id: breakItem.id,
        start_at: breakItem.start_at,
        end_at: breakItem.end_at
      }));
  
      const workingHourId = workingHour?.id;
      setError('');

      const data = {
        content_type: 'string',
        start_at: workStartTime,
        end_at: workEndTime,
        breaks: breaks,
        object_id: workingHourId,
      };

      try {     
        // TODO CHIARA guarda qui!!!!! daiiii daiiii daiiii  
        validateBreaks(workStartTime, workEndTime, pauseTimes);
        validateTimeSlots(workStartTime, workEndTime,  workingHour.time_slots);       
      }
      catch (error) {
        setError(error.message);
        setIsSaving(false);
        return;
      }
      
      const response = await createTimeSlotCompanyCompound(token, data, 'workinghour', workingHourId);
      
      const updatedTimeSlots = [...workingHour.time_slots, response]; 

      setNewTimeSlots(updatedTimeSlots);
            
      if (onAddTimeSlot) {
        onAddTimeSlot(response);
        setError('');
      }
      
      setWorkStartTime('');
      setWorkEndTime('');
      setPauseTimes([]);
      setCreatingPause(false);
  
      handleCancelClick();
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Salvato!",
        showConfirmButton: false,
        timer: 1500
      });
    } catch (error) {
      console.error('Errore durante la creazione del time slot:', error);
  
      let errorMessage = 'Errore durante la creazione della fascia oraria. Per favore riprova.';

      if (!error.response) {
        errorMessage = 'Errore, riprova più tardi.';
      } else if (error.response && error.response.data) {
        const errorData = error.response.data;
        const errorMessages = [];

        Object.keys(errorData).forEach((key) => {
          const messageArray = errorData[key];
          if (Array.isArray(messageArray)) {
            errorMessages.push(...messageArray);
          } else if (typeof messageArray === 'string') {
            errorMessages.push(messageArray);
          }
        });

        if (errorMessages.length > 0) {
          errorMessage = errorMessages.join(' ');
        }
      }
  
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      {(
        <div className='border border-solid-2 border-gray-200 shadow-md rounded-md my-5 bg-white'>
          <div className='grid grid-cols-1 mx-4 mt-4'>
            <label htmlFor="parent" className="text-sm font-medium text-gray-700 m-0 col-span-1 flex items-center">Inserisci Fascia Oraria * </label>
            {error && (
            <div className="grid grid-cols-1 mx-4">
              <p className="text-red-500 text-sm text-center">{error}</p>
            </div>
            )}
            <div className='grid md:grid-cols-6 sm:grid-cols-1 gap-3 mt-4 justify-between'>
              <div className='md:col-span-3 sm:col-span-1'>
                <div className="mb-3 flex items-center">
                  <label htmlFor="start-time" className="w-32 text-sm font-medium text-gray-700 flex items-center space-x-1">
                    <BriefcaseIcon className='h-5 w-5 mr-2' />
                    Dalle ore:
                  </label>
                  <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                    <input 
                      type="text"
                      placeholder='hh:mm' 
                      value={workStartTime} 
                      onInput={handleWorkStartTimeChange}
                      onBlur={() => handleWorkTimeBlur('start')}
                      className="mt-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block w-32 shadow-md sm:text-sm required" 
                      style={{ paddingRight: '2.5rem' }}
                    />
                    <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                      <ClockIcon className='w-4 h-4' />
                    </span>
                  </div>
                </div>
              </div>
          
              <div className='md:col-span-3 sm:col-span-1 flex items-center'>
                <label htmlFor="start-time" className="w-32 text-sm font-medium text-gray-700 flex items-center space-x-1">
                  <BriefcaseIcon className='h-5 w-5 mr-2' />
                  Alle ore:
                </label>
                <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                  <input 
                    type="text"
                    placeholder='hh:mm' 
                    value={workEndTime} 
                    onInput={handleWorkEndTimeChange} 
                    onBlur={() => handleWorkTimeBlur('end')}
                    className="t-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block w-32 shadow-md sm:text-sm required" 
                  />
                  <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                    <ClockIcon className='w-4 h-4' />
                  </span>
                </div>
              </div>
            </div>
          </div>

          {workTimeError && (
            <p className="text-red-500 text-sm justify-center flex pt-8 ">{workTimeError}</p>
          )}

          {breakTimeError && (
            <p className="text-red-500 text-sm justify-center flex pt-8 ">{breakTimeError}</p>
          )}

          <div className='grid md:grid-cols-6 sm:grid-cols-1 mx-4 pt-7 items-center'>
            <div className='col-span-6 flex items-center'>
              <label htmlFor="parent" className="block text-sm font-medium text-gray-700 m-0 col-span-1">Inserisci Fascia Oraria della Pausa</label>
              {!creatingPause && !pauseTimes.some(pause => !pause.confirmed) ? (
                <button onClick={handleAddPause} className="ml-3 border rounded-md bg-white py-1 px-2 mr-2 text-center text-sm font-semibold text-gray-700 shadow-md hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500 flex items-center">
                  <PlusIcon className='w-5 h-5 text-indigo-500 mr-1' />  
                  AGGIUNGI PAUSA
                </button>
              ) : (
                <button onClick={() => { setCreatingPause(false); setPauseTimes(pauseTimes.filter(pause => pause.confirmed)), setBreakTimeError('') }} className="ml-3 border rounded-md bg-white py-1 px-2 mr-2 text-center text-sm font-semibold text-gray-700 shadow-md hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500 flex items-center">
                  ANNULLA
                </button>
              )}
            </div>
          </div>
          

          {pauseTimes.map((pause, index) => (
            <div key={index} className="grid md:grid-cols-6 sm:grid-cols-1 mx-4 mt-4 justify-between">
              {!pause.confirmed ? (
                <>
                  <div className="md:col-span-2 sm:col-span-1 flex items-center">
                  <label htmlFor="start-time" className="w-32 text-sm font-medium text-gray-700 flex items-center space-x-1">
                    <SvgBreak />
                    Dalle ore:
                </label>
                    <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                      <input 
                        type="text"
                        placeholder='hh:mm' 
                        value={pause.start_at} 
                        onInput={(e) => handlePauseStartTimeChange(index, e)}
                        onBlur={() => handlePauseTimeBlur(index, 'start_at')} 
                        className="mt-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block w-32 shadow-md sm:text-sm" 
                        disabled={!workStartTime || !workEndTime || pause.confirmed} 
                      />
                      <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                        <ClockIcon className='w-4 h-4' />
                      </span>
                    </div>
                  </div>
                  <div className="col-span-2 sm:col-span-1"></div>
                  <div className="md:col-span-2 sm:col-span-1 flex items-center">
                    <label htmlFor="start-time" className="w-32 text-sm font-medium text-gray-700 flex items-center space-x-1">
                      <SvgBreak />
                      Alle ore:
                    </label>
                    
                    <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                      <input 
                        type="text" 
                        placeholder='hh:mm'
                        value={pause.end_at} 
                        onInput={(e) => handlePauseEndTimeChange(index, e)} 
                        onBlur={() => handlePauseTimeBlur(index, 'end_at')} 
                        className="mt-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block w-32 shadow-md sm:text-sm" 
                        disabled={!workStartTime || !workEndTime || pause.confirmed} 
                      />
                      <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                        <ClockIcon className='w-4 h-4' />
                      </span>
                    </div>
                  </div>
                  <div className='sm:col-span-1 flex items-center ml-2'>
                    <button
                        onClick={() => handleConfirmPause(index)}
                        className="bg-indigo-600 text-white text-xs font-semibold p-2 rounded-md hover:bg-indigo-500 focus:outline-none focus:bg-indigo-600 flex items-center justify-center uppercase"
                    >
                        Aggiungi
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="md:col-span-2 sm:col-span-1 flex items-center">
                    
                    <label htmlFor="start-time" className="w-32 text-sm font-medium text-gray-700 flex items-center space-x-1">
                      <SvgBreak />
                      Dalle ore:
                    </label>
                    <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                      <input type="time" value={pause.start_at} className="mt-1 p-1 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block w-32 shadow-md sm:text-sm" disabled />
                      <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                        <ClockIcon className='w-4 h-4' />
                      </span>
                    </div>
                  </div>

                  <div className="col-span-2 sm:col-span-1"></div>
                  <div className="md:col-span-2 sm:col-span-1 flex items-center">
                    <label htmlFor="start-time" className="w-32 text-sm font-medium text-gray-700 flex items-center space-x-1">
                      <SvgBreak />
                      Alle ore:
                    </label>
                    <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                      <input type="time" value={pause.end_at} className="mt-1 p-1 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block w-32 shadow-md sm:text-sm" disabled />
                      <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                        <ClockIcon className='w-4 h-4' />
                      </span>
                    </div>
                  </div>
                  <div className='col-span-1 flex items-center ml-2'>
                    <button onClick={() => handleDeletePause(index)} className="bg-white text-gray-900 text-sm p-2 rounded-md hover:text-red-600 focus:outline-none focus:text-gray-900 h-8 flex items-center text-left">
                      <TrashIcon className="h-5 w-5 mr-2" />
                    </button>
                  </div>
                </>
              )}
            </div>
          ))}
          <div className='grid grid-cols-2 gap-2 mt-7 mb-4'>
            <div className='col-span-1 flex justify-end'>
              <button 
                onClick={handleSaveTimeSlot} 
                className="bg-indigo-600 text-white text-sm px-4 py-2 rounded-md hover:bg-indigo-500 focus:outline-none focus:bg-indigo-600 w-24 font-semibold uppercase  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
                disabled={isSaving}
                >
                    {isSaving ? 'Salvataggio...' : 'Salva'}
                </button>
            </div>

            <div className="col-span-1 flex justify-start">
              <button onClick={handleCancelClick} className="bg-gray-300 text-gray-700 text-sm px-4 py-2 rounded-md ml-4 hover:bg-gray-400 focus:outline-none focus:bg-gray-200 w-24 font-semibold uppercase focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500">Annulla</button>
            </div>

          </div>
        </div>
      )}
    </>
  );
}

export default AddNewTimeSlot;


const SvgBreak = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 117 122.88" style={{ width: '19px', margin: '4px' }}>
          <g>
              <path d="M94.8,15.36c-1.18-0.34-1.86-1.56-1.53-2.74c0.34-1.18,1.56-1.86,2.74-1.53c3.15,0.9,5.79,2.39,7.82,4.59 c2.03,2.22,3.39,5.1,3.94,8.79c0.18,1.21-0.66,2.34-1.88,2.52c-1.21,0.18-2.34-0.66-2.52-1.88c-0.41-2.76-1.38-4.87-2.81-6.43 C99.13,17.12,97.17,16.04,94.8,15.36L94.8,15.36z M37.87,67.17L0.61,28.09c-0.84-0.89-0.81-2.29,0.08-3.13 c0.43-0.41,0.98-0.61,1.53-0.61v-0.01h14.53L2.27,9.86c-0.87-0.87-0.87-2.27,0-3.14c0.87-0.87,2.27-0.87,3.14,0l17.62,17.62h42.2 c0.46-6.48,3.24-12.31,7.52-16.64C77.44,2.94,83.92,0,91.08,0c7.16,0,13.64,2.94,18.34,7.7C114.1,12.45,117,19,117,26.23 c0,7.23-2.9,13.78-7.58,18.53c-4.7,4.76-11.18,7.7-18.34,7.7c-3.19,0-6.25-0.59-9.09-1.66c-2.33-0.88-4.51-2.1-6.48-3.6L56,67.18 v38.38l14.94,13.45c0.91,0.82,0.98,2.22,0.16,3.13c-0.44,0.49-1.04,0.73-1.65,0.73v0H24.77c-1.23,0-2.22-0.99-2.22-2.22 c0-0.7,0.32-1.32,0.82-1.73l14.5-13.36V67.17L37.87,67.17z M69.68,24.34h22.88c1.23,0,2.22,0.99,2.22,2.22 c0,0.66-0.29,1.26-0.75,1.67L78.64,44c1.5,1.08,3.15,1.98,4.92,2.65c2.33,0.88,4.87,1.37,7.52,1.37c5.93,0,11.3-2.43,15.18-6.36 c3.89-3.94,6.3-9.39,6.3-15.42c0-6.03-2.41-11.48-6.3-15.42c-3.88-3.93-9.25-6.36-15.18-6.36c-5.93,0-11.3,2.43-15.18,6.36 C72.42,14.33,70.13,19.06,69.68,24.34L69.68,24.34z M7.4,28.78l6.82,7.15c0.14-0.03,0.29-0.05,0.45-0.05h64.77 c0.28,0,0.54,0.05,0.79,0.14l7.08-7.25H7.4L7.4,28.78z M18.41,40.33l23.18,24.31c0.45,0.41,0.73,0.99,0.73,1.65v40.26h0 c0,0.6-0.24,1.2-0.72,1.63l-11.14,10.26h33.22l-11.29-10.16c-0.5-0.41-0.83-1.03-0.83-1.73V66.28h0.01c0-0.56,0.21-1.11,0.63-1.55 l23.83-24.41H18.41L18.41,40.33z"/>
          </g>
      </svg>
  );
};